import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppNS } from 'app';
import { apiEditPermissions, apiGetEmployee } from 'app/api/employees/employees';

import { AppThunk } from './index';

export interface EmployeesState {
  employee: AppNS.Employment | null;
  isLoading: boolean;
  isUpdating: boolean;
  isUpdateSuccess: boolean;
  updatingErrors: any;
}

const initialState: EmployeesState = {
  employee: null,
  isLoading: false,
  isUpdating: false,
  isUpdateSuccess: false,
  updatingErrors: null,
};

const employeesStateSlice = createSlice({
  name: 'employees',
  initialState,
  reducers: {
    getEmployeeStart(state: EmployeesState) {
      state.isLoading = true;
      state.updatingErrors = null;
      state.isUpdateSuccess = false;
    },
    getEmployeeSuccess(
      state: EmployeesState,
      action: PayloadAction<AppNS.Employment>
    ) {
      state.employee = action.payload;
      state.isLoading = false;
    },
    getEmployeeFailed(state: EmployeesState) {
      state.isLoading = false;
    },
    updateEmployeeStart(state: EmployeesState) {
      state.isUpdating = true;
      state.updatingErrors = null;
      state.isUpdateSuccess = false;
    },
    updateEmployeeSuccess(
      state: EmployeesState,
      action: PayloadAction<AppNS.Params>
    ) {
      state.employee = {...state.employee, ...action.payload.properties};
      state.isUpdating = false;
      state.isUpdateSuccess = true;
    },
    updateEmployeeFailed(state: EmployeesState, action: PayloadAction<any>) {
      state.isUpdating = false;
      state.updatingErrors = action.payload;
      state.isUpdateSuccess = false;
    },
  },
});

export const {
  getEmployeeStart,
  getEmployeeFailed,
  getEmployeeSuccess,
  updateEmployeeStart,
  updateEmployeeSuccess,
  updateEmployeeFailed,
} = employeesStateSlice.actions;

export default employeesStateSlice.reducer;

export const getEmployee = (id: string): AppThunk => async (dispatch) => {
  try {
    dispatch(getEmployeeStart());
    const data = await apiGetEmployee(id);

    dispatch(getEmployeeSuccess(data as AppNS.Employment));
  } catch (err) {
    console.error(err.toString());
    dispatch(getEmployeeFailed());
  }
};

export const updateEmployee = (params: AppNS.Params): AppThunk => async (dispatch) => {
  try {
    dispatch(updateEmployeeStart());
    const result = await apiEditPermissions(params);
    dispatch(updateEmployeeSuccess(result.model));
  } catch (err) {
    dispatch(updateEmployeeFailed(err));
  }
};
